jQuery(document).ready(function ($) {
  var cookieName = "hideAlertBar";

  $(".alert-bar__close").click(function (e) {
    $(".alert-bar__wrapper").addClass("dismissed");
    var newCookie = cookieName + "=true";
    document.cookie = newCookie;
  });

  var allCookies = document.cookie;

  // this all runs on document ready - alert bar starts hidden and if no cookie present brings it to life!
  // if string has length
  if (allCookies) {
    var cookieNameExists = allCookies.indexOf(cookieName);

    // if cooke name doesn't exist, then show the banner
    if (cookieNameExists === -1) {
      $(".alert-bar__wrapper").removeClass("dismissed");
    }
  } else {
    // if no cookies present, show the alert bar
    $(".alert-bar__wrapper").removeClass("dismissed");
  }
});
